import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./media-queries.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Navigation from "./components/Shared/navigation-header";
import Home from "./components/Index/home";
import About from "./components/About/about";
import Contact from "./components/Contact/contact";
import Recipes from "./components/Recipes/recipes";
import Recipe from "./components/Recipes/recipe";
import Footer from "./components/Footer/footer";

function App() {
  return (
    <Router>
      <Navigation />
      <div className="apply-spacing">
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/recipes" component={Recipes} />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
          <Route path="/recipe/:id" component={Recipe} />
        </Switch>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
